export default {
  type: 'header',
  title: `Heading`,
  icon: `header`,
  template: (config) => `
      <h1
        data-level="{{feature.level}}"
        contenteditablebind
        contenteditable="true"
        feature-obj="feature"
        org-index="orgIndex"
        data-index="${config.index}"
        ng-model="feature.content"
        ng-bind-html="feature.content"
        data-xplaceholder="Type your header here."
        ng-attr-data-placeholder="{{(!feature.content.trim().length && 'Type your header here.') || '' }}">
      </h1>
    `,
  propertyTemplate: `<div class="form-group row" data-testid="template-header-level-selection-modal">
        <p class="clearfix">Pick the level of the heading by clicking on it.</p>
        <div class="list-group">
          <h1
            data-level="1"
            ng-click="feature.level=1"
            class="list-group-item list-group-item-action"
            ng-class="{ 'active' : feature.level==1 }"
            data-testid="heading-level-1-item"
            >Heading Level 1</h1>
          <h1
            data-level="2"
            ng-click="feature.level=2"
            class="list-group-item list-group-item-action"
            ng-class="{ 'active' : feature.level==2 }"
            data-testid="heading-level-2-item"
            >Heading Level 2</h1>
          <h1
            data-level="3"
            ng-click="feature.level=3"
            class="list-group-item list-group-item-action"
            ng-class="{ 'active' : feature.level==3 }"
            data-testid="heading-level-3-item"
            >Heading Level 3</h1>
          <h1
            data-level="4"
            ng-click="feature.level=4"
            class="list-group-item list-group-item-action"
            ng-class="{ 'active' : feature.level==4 }"
            data-testid="heading-level-4-item"
            >Heading Level 4</h1>
          <h1
            data-level="5"
            ng-click="feature.level=5"
            class="list-group-item list-group-item-action"
            ng-class="{ 'active' : feature.level==5 }"
            data-testid="heading-level-5-item"
            >Heading Level 5</h1>
          <h1
            data-level="6"
            ng-click="feature.level=6"
            class="list-group-item list-group-item-action"
            ng-class="{ 'active' : feature.level==6 }"
            data-testid="heading-level-6-item"
            >Heading Level 6</h1>
        </div>
      </div>`,
  onPaste: function (elem) {
    return {
      type: 'header',
      level: parseInt(
        elem
          .prop('tagName')
          .toLowerCase()
          .match(/h(\d+)/)[1]
      ),
      content: elem.html(),
    }
  },
  initialInflation: function () {
    return {
      type: 'header',
      content: '',
      level: 2,
    }
  },
  convertable: true,
  openPropertyTemplateOnAdd: false,
}
